export default function Footer() {
  return (
    <footer className="py-8 bg-gray-800 text-center text-white">
      <p>© 2024 Eric Kittelson. All rights reserved. Built with passion and purpose.</p>
    </footer>
  );
}
